import { render, staticRenderFns } from "./InfoIDPopup.vue?vue&type=template&id=3d968336"
import script from "./InfoIDPopup.vue?vue&type=script&lang=js"
export * from "./InfoIDPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports